<!--
* UI Name: Process Detail
* Modify Date: 2021.12.22
-->
<template>
  <div class="pa-4 custome-border-component fixed-height-comp">
    <!-- Header -->
    <v-row class="page-header mt-0">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold custom-title">{{ $t("lbl.admin.process_detail") }}</v-toolbar-title>
      </v-col>
    </v-row>
    <!-- Condition search -->
    <v-row class="custom-form-control admin-process-style custom-figma-1 mb-0">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
          >
            <v-row>
              <v-col cols="6" lg="6" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="searchProcessId"
                  @keyup.enter="searchData"
                  :label="$t('lbl.admin.processSearch')"
                  dense
                  filled
                  class="custom-selectbox"
                ></v-text-field>
              </v-col>
              <v-col cols="6" lg="6" md="6" class="pt-0 pb-0">
                <div class="pa-0 btn-control text-right">
                  <v-btn class="btn btn-top btn-search btn-width-1" color="primary" @click="searchData">
                    <v-icon x-small class="mr-2">fa fa-search</v-icon>
                    {{ $t("btn.common.search") }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="search-detail-style">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.owner") }}</span>
            <span>{{stateViewInfo.groupId}}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.company") }}</span>
            <span>{{stateViewInfo.userId}}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.process") }}</span>
            <span>{{stateViewInfo.processId}}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.status") }}</span>
            <span>
              <font
                :color="stateViewInfo.transactionCode ? statusColor(stateViewInfo.transactionCode) : ''"
              >{{statusText(stateViewInfo.transactionCode)}}</font>
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="search-detail-style">
      <v-col class="page-control-content page-control-bg transaction-pagi pb-10">
        <v-row>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.sender") }}</span>
            <span>{{stateViewInfo.senderId}}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.receiver") }}</span>
            <span>{{stateViewInfo.recipientId}}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.message") }}</span>
            <span>{{stateViewInfo.messageName}}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t("lbl.admin.partner") }}</span>
            <span>{{stateViewInfo.partnerName}}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="pt-3">
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0 mb-3">
        <v-data-table
          :headers="headers"
          :items="listData"
          :class="['list-table admin-process-style srm-list-table custom-border-table', listData.length > 0 ? '' : 'custom-border-table-not-data']"
          :fixed-header="true"
          hide-default-footer
          :height="tableHeight"
          disable-pagination
          disable-sort
          group-by="processSetupName"
          group-desc
        >
          <template v-slot:item.procSetupSeq="{ item }">
            <div class="index-col">{{item.INDEX}}</div>
          </template>
          <template v-slot:group.header="{ group, items, isOpen, toggle, remove }">
            <td colspan="12" class="pl-0">
              <v-btn icon @click="toggle" class="ml-0">
                <v-icon v-if="isOpen" small>mdi-minus</v-icon>
                <v-icon v-else small>mdi-plus</v-icon>
              </v-btn>
              <span class="ml-1">{{ items[0].groupIndex + '. Workflow Name : ' + items[0].procName + ' '}}</span>
              <a
                class="link-file-text"
                @click="openProcessEventHistory(items[0].processSetupId)"
              >{{ '[' + items[0].processSetupId + ']' }}</a>
            </td>
          </template>
          <template v-slot:item.procType="{ item }">
            <v-btn
              v-if="item.procType.indexOf(`COM`) !== -1"
              class="mr-1"
              x-small
              color="proc darken-1"
              height="30"
            >
              <icon-svg
                v-if="item.procType.indexOf(`COM`) !== -1"
                :size="procIconSize"
                iconName="proc-comm"
              />
            </v-btn>
            <v-btn
              v-if="item.procType.indexOf(`DIR`) !== -1"
              class="mr-1"
              x-small
              color="proc darken-1"
              height="30"
            >
              <icon-svg
                v-if="item.procType.indexOf(`DIR`) !== -1"
                :size="procIconSize"
                iconName="proc-folder"
              />
            </v-btn>

            <v-btn
              v-if="item.procType.indexOf(`SET`) !== -1"
              class="mr-1"
              x-small
              color="proc darken-1"
              height="30"
            >
              <v-icon v-if="item.procType.indexOf(`SET`) !== -1" small>fa fa-gift</v-icon>
            </v-btn>

            <v-btn
              v-if="item.procType.indexOf(`MAP`) !== -1"
              class="mr-1"
              x-small
              color="proc darken-1"
              height="30"
            >
              <icon-svg
                v-if="item.procType.indexOf(`MAP`) !== -1"
                :size="procIconSize"
                iconName="proc-mapper"
              />
            </v-btn>

            <v-btn
              v-if="item.procType.indexOf(`ENV`) !== -1"
              class="mr-1"
              x-small
              color="proc-envel darken-1"
              height="30"
            >
              <v-icon v-if="item.procType.indexOf(`ENV`) !== -1" small>fa fa-envelope</v-icon>
            </v-btn>
            <v-btn
              v-if="item.procType.indexOf(`MQ`) !== -1"
              class="mr-1"
              x-small
              color="proc darken-1"
              height="30"
              style="width: 44px;"
            >mq</v-btn>
          </template>

          <template v-slot:item.transactionCode="{ item }">
            <span>
              <font
                :color="statusColor_list(item.transactionCode, item.errorMessage)"
              >{{statusText_list(item.transactionCode, item.errorMessage)}}</font>
            </span>
          </template>
          <template v-slot:item.fileLink="{ item }">
            <a
              v-if="item.fileLink !== undefined && item.fileLink !== undefined"
              class="link-file-text cursor-pointer layout-col"
              @click="openDataInformationFileViewWindow(item)"
            >{{$t('btn.common.view')}}</a>
          </template>

          <template v-slot:item.reProcess="{ item }">
            <a @click="executeReProcess()">
              <v-icon small class="mr-1">mdi-play-box-outline</v-icon>
            </a>
          </template>
          <template v-slot:item.procCommId="{ item }">
            <span v-if="item.procType.indexOf(`COM`) !== -1">{{item.host_port}}</span>
            <!-- <span v-if="item.procType.indexOf(`CVT`) !== -1">{{item.cvtrNm}}</span>
            <span v-if="item.procType.indexOf(`FLT`) !== -1">{{item.fltrNm}}</span>-->
            <span v-if="item.procType.indexOf(`DIR`) !== -1">{{item.foldNm}}</span>
            <span v-if="item.procType.indexOf(`MAP`) !== -1">{{item.mappingName}}</span>
            <span v-if="item.procType.indexOf(`MQ`) !== -1">{{item.mqName}}</span>
          </template>
          <template v-slot:item.timestamp="{ item }">
            <span>
              <font v-if="item.timestamp !== undefined">{{applyGmtTimeZone(item.timestamp)}}</font>
            </span>
          </template>
          <template v-slot:item.errorMessage="{ item }">
            <span>
              <font v-if="item.errorMessage !== undefined">{{item.errorMessage}}</font>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <monitoringDataInfoFileViewWindow
        v-if="dialog.type == 'monitoringDataInfoFileViewWindow'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :dataInfo="tempDataInfo"
      ></monitoringDataInfoFileViewWindow>
    </div>
    <dialogWindow
      ref="searchEventHistory"
      size="max"
      :detail="$t('lbl.admin.input_process')"
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import $ from "jquery";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import { mapState } from "vuex";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import IconSvg from "@/vue-caas/components/IconBase.vue";
const moment = require("moment");

export default {
  components: {
    SystemProgress,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
    dialogWindow,
  },

  props: {
    processId: {
      default: "",
    },
    groupId: {
      default: "",
    },
  },

  data() {
    return {
      stateViewInfo: {
        groupId: "",
        userId: "",
        processSetupId: "",
        processId: "",
        messageSequence: 0,
        senderId: "",
        recipientId: "",
        messageName: "",
        partnerName: "",
        direction: "",
        transactionCode: "",
      },
      headers: [
        {
          text: this.$t("tbl.common.columnNo"),
          value: "procSetupSeq",
          width: "40px",
          sortable: false,
        },
        {
          text: "Comp.",
          value: "procType",
          align: "center",
          width: "60px",
          sortable: false,
        },
        {
          text: "Route Info.",
          value: "procCommId",
          width: "280px",
          sortable: false,
        },
        {
          text: "Status",
          value: "transactionCode",
          align: "center",
          width: "50px",
          sortable: false,
        },
        {
          text: "Processed Date",
          value: "timestamp",
          align: "center",
          width: "160px",
          sortable: false,
        },
        {
          text: "Error Message",
          value: "errorMessage",
          width: "160px",
          sortable: false,
        },
        {
          text: "Data Info.",
          value: "fileLink",
          align: "center",
          width: "160px",
          sortable: false,
        },
        {
          text: "Re-process",
          value: "reProcess",
          align: "center",
          width: "160px",
          sortable: false,
        },
      ],
      procIconSize: 24,
      searchProcessId: "",
      listData: [],
      isCreated: false,
      tableHeight: "",
      isLoading: false,
      dialogs: [],
      dialogId: 1,
      dialog: false,
      arrLayoutDialog: [],
      tempDataInfo: [],
      processViewArr: []
    };
  },

  computed: {
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },

  watch: {
    processId() {
      this.searchProcessId = this.processId;
      this.searchData();
    },
  },

  created() {
    this.isCreated = true;
  },
  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 156 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 156 + "px";
    });
  },
  mounted() {
    if (this.processId) {
      this.searchProcessId = this.processId;
      this.searchData();
    } 
  },

  methods: {
    executeReProcess() {
      alert("executeReProcess");
    },
    directionText(direction) {
      if (direction === "I") return "Inbound";
      else if (direction === "O") return "Outbound";
    },

    statusColor(status) {
      if (status.indexOf("SEND_O_DONE") !== -1) return "#2a8c72";
      else if (status.indexOf("FAIL") !== -1) return "#EB1E50";
      else if (status.indexOf(undefined) !== -1) return "#EB1E50";
      else return "#6F5ECE";
    },

    statusColor_list(status, errMsg) {
      if (status !== undefined) {
        if (
          status.indexOf("DONE") !== -1 &&
          (errMsg === undefined || errMsg === "")
        )
          return "#2a8c72";
        else if (
          status.indexOf("FAIL") !== -1 ||
          (errMsg !== undefined && errMsg !== "")
        )
          return "#EB1E50";
        else if (status.indexOf(undefined) !== -1) return "#EB1E50";
        else return "#6F5ECE";
      }
    },
    statusText_list(status, errMsg) {
      if (status !== undefined) {
        if (
          status.indexOf("DONE") !== -1 &&
          (errMsg === undefined || errMsg === "")
        )
          return "OK";
        else if (
          status.indexOf("FAIL") !== -1 ||
          (errMsg !== undefined && errMsg !== "")
        )
          return "Error";
        else if (status.indexOf(undefined) !== -1) return "Unknown";
        else return "Processing";
      }
    },
    applyGmtTimeZone(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        newM = moment
          .utc(date)
          .add(this.$cookies.get("gmt-timezone"), "hours")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },

    statusText(status) {
      if (!status) return "";
      if (status.indexOf("SEND_O_DONE") !== -1) return "OK";
      else if (status.indexOf("FAIL") !== -1) return "Error";
      else if (status.indexOf(undefined) !== -1) return "Unknown";
      else return "Processing";
    },

    searchData() {
      let str = this.searchProcessId.replace(/\s/g, "");
      if (!str) {
        if (this.processId) this.searchProcessId = this.processId;
        this.$refs.searchEventHistory.dialog = true;
        return;
      }

      let ownerId = this.groupId;
      if(!ownerId) ownerId = this.$cookies.get("ownr-id");

      this.isLoading = true;
      const params = {
        searchProcessId: str,
        ownerId: ownerId,
      };

      (this.stateViewInfo = {
        groupId: "",
        userId: "",
        processSetupId: "",
        processId: "",
        messageSequence: 0,
        senderId: "",
        recipientId: "",
        messageName: "",
        partnerName: "",
        direction: "",
        transactionCode: "",
      }),
        (this.listData = []);
        //console.log('params.ownerId: ', params.ownerId);
      this.$store
        .dispatch("getProcessDetailList", params)
        .then(() => {
          let data = this.$store.getters.processDetailData;
          this.listData = data.procDataList;
          this.stateViewInfo = data.stateViewInfo;
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },

    openDataInformationFileViewWindow(rowItem) {
      let item = {
        processId: `${this.stateViewInfo.processId}`,
        senderId: `${this.stateViewInfo.senderId}`,
        recipientId: `${this.stateViewInfo.recipientId}`,
        partnerName: `${this.stateViewInfo.partnerName}`,
        messageName: `${this.stateViewInfo.messageName}`,
        direction: `${this.stateViewInfo.direction}`,
        fileLink: `${rowItem.fileLink}`,
        // userData: "",
        userData: JSON.stringify(rowItem.userData),
      };
      // 2022.05.16 213979 SPKA-460 open new window popup
      this.openDataInfo(item);
    },
    openProcessEventHistory(processSetupId) {
      this.$emit("change-history", processSetupId);
    },
    openDataInfo(data) {
      let message = {
        message: "open-state-file" + JSON.stringify(data),
      };
      window.postMessage(message, "*");
      this.$emit("select-ok", data);
    },
  },
};
</script>